"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarningStatusChip = exports.EmbeddableWarningStatusChip = exports.WarningStatusIcon = exports.EmbeddableWarningStatusIcon = exports.CertificationStatusChipOrIcon = exports.EmbeddableCertificationStatusChipOrIcon = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var DataCatalogProvider_1 = require("../DataCatalogProvider");
var DataQualityType_1 = require("../dataQualityWarnings/DataQualityType");
var DataQualityIndicatorStyles_1 = require("../style/DataQualityIndicatorStyles");
var SiteUrlsContext_1 = require("../urls/SiteUrlsContext");
var TypescriptHelpers_1 = require("../utils/TypescriptHelpers");
var DataQualityIndicatorButtons_1 = require("./DataQualityIndicatorButtons");
var DataQualityIndicatorDetail_1 = require("./DataQualityIndicatorDetail");
var DataQualityIndicatorFragments_1 = require("./DataQualityIndicatorFragments");
var DataQualityIndicatorSharedHelpers_1 = require("./DataQualityIndicatorSharedHelpers");
function usePanelState(testId) {
    var ref = React.useRef(null);
    var _a = React.useState(false), isDialogOpen = _a[0], setIsDialogOpen = _a[1];
    var onCloseRequest = React.useCallback(function () { return setIsDialogOpen(false); }, [setIsDialogOpen]);
    var onClick = React.useCallback(function () { return setIsDialogOpen(!isDialogOpen); }, [isDialogOpen, setIsDialogOpen]);
    return {
        isDialogOpen: isDialogOpen, onCloseRequest: onCloseRequest, onClick: onClick, testId: testId, ref: ref
    };
}
function shouldSkipWarningDueToNoIndicators(_a) {
    var anchoredChildWarnings = _a.anchoredChildWarnings, upstreamWarnings = _a.upstreamWarnings, rest = __rest(_a, ["anchoredChildWarnings", "upstreamWarnings"]);
    var hasNoChildWarnings = (anchoredChildWarnings !== null && anchoredChildWarnings !== void 0 ? anchoredChildWarnings : []).filter(function (t) { return t.isActive; }).length < 1;
    var hasNoUpstreamWarnings = upstreamWarnings.filter(function (t) { return t.isActive; }).length < 1;
    switch (rest.kind) {
        case 'graph': return rest.anchoredWarnings.filter(function (t) { return t.isActive; }).length < 1 && hasNoUpstreamWarnings && hasNoChildWarnings;
        case 'vizportal': return rest.anchoredWarnings.filter(function (t) { return t.isActive; }).length < 1 && hasNoUpstreamWarnings && hasNoChildWarnings;
        default:
            TypescriptHelpers_1.assertUnreachable(rest);
            return true;
    }
}
function shouldSkipCertificationDueToNoIndicators(props) {
    switch (props.kind) {
        case 'graph': return props.anchoredCertifications.filter(function (t) { return t.isActive; }).length < 1;
        case 'vizportal': return props.anchoredCertifications.filter(function (t) { return t.isActive; }).length < 1;
        default:
            TypescriptHelpers_1.assertUnreachable(props);
            return true;
    }
}
var DataQualityCertificationStatusChipId = 'data-quality-certification-chip-id';
function EmbeddableCertificationStatusChipOrIcon(props) {
    var siteUrls = props.siteUrls, rest = __rest(props, ["siteUrls"]);
    return (React.createElement(DataCatalogProvider_1.SiteUrlsProvider, { siteUrls: siteUrls },
        React.createElement(CertificationStatusChipOrIcon, __assign({}, rest))));
}
exports.EmbeddableCertificationStatusChipOrIcon = EmbeddableCertificationStatusChipOrIcon;
function CertificationStatusChipOrIcon(props) {
    var _a = usePanelState(DataQualityCertificationStatusChipId), isDialogOpen = _a.isDialogOpen, onCloseRequest = _a.onCloseRequest, ref = _a.ref, rest = __rest(_a, ["isDialogOpen", "onCloseRequest", "ref"]);
    if (shouldSkipCertificationDueToNoIndicators(props)) {
        return null;
    }
    var title = certificationTooltipTitle(props);
    var indicators = DataQualityIndicatorFragments_1.mapRenderCertificationsToIndicatorProps(props);
    return (React.createElement(SiteUrlsContext_1.SiteUrlsContext.Provider, { value: props.urls || SiteUrlsContext_1.noopSiteUrls },
        React.createElement(DataQualityIndicatorButtons_1.DataQualityCertificationInteractiveButtonOrIcon, __assign({}, rest, { iconOnly: props.iconOnly, ref: ref, tabIndex: props.tabIndex })),
        isDialogOpen &&
            React.createElement(DataQualityIndicatorDetailPanel, { indicators: indicators, onCloseRequest: onCloseRequest, side: props.side || 'right', title: title, anchorEl: ref.current, stackingRootId: props.stackingRootId })));
}
exports.CertificationStatusChipOrIcon = CertificationStatusChipOrIcon;
var DataQualityWarningStatusChipId = 'data-quality-warning-chip-id';
function buildWarningTooltipAndPanelProps(props) {
    var warningKind = getWarningKind(props);
    var title = warningTooltipTitle(props);
    var indicators = DataQualityIndicatorFragments_1.mapRenderWarningsToIndicatorsProps(props);
    return { warningKind: warningKind, title: title, indicators: indicators };
}
function EmbeddableWarningStatusIcon(props) {
    var siteUrls = props.siteUrls, rest = __rest(props, ["siteUrls"]);
    return (React.createElement(DataCatalogProvider_1.SiteUrlsProvider, { siteUrls: siteUrls },
        React.createElement(WarningStatusIcon, __assign({}, rest))));
}
exports.EmbeddableWarningStatusIcon = EmbeddableWarningStatusIcon;
function WarningStatusIcon(props) {
    var _a = usePanelState(DataQualityWarningStatusChipId), isDialogOpen = _a.isDialogOpen, onCloseRequest = _a.onCloseRequest, ref = _a.ref, rest = __rest(_a, ["isDialogOpen", "onCloseRequest", "ref"]);
    if (shouldSkipWarningDueToNoIndicators(props)) {
        return null;
    }
    var _b = buildWarningTooltipAndPanelProps(props), warningKind = _b.warningKind, title = _b.title, indicators = _b.indicators;
    return (React.createElement(SiteUrlsContext_1.SiteUrlsContext.Provider, { value: props.urls || SiteUrlsContext_1.noopSiteUrls },
        React.createElement(DataQualityIndicatorButtons_1.DataQualityWarningInteractiveIcon, __assign({}, rest, { warningKind: warningKind, title: title, ref: ref, tabIndex: props.tabIndex })),
        isDialogOpen &&
            React.createElement(DataQualityIndicatorDetailPanel, { indicators: indicators, onCloseRequest: onCloseRequest, side: props.side || 'right', title: title, anchorEl: ref.current, stackingRootId: props.stackingRootId })));
}
exports.WarningStatusIcon = WarningStatusIcon;
function EmbeddableWarningStatusChip(props) {
    var siteUrls = props.siteUrls, rest = __rest(props, ["siteUrls"]);
    return (React.createElement(DataCatalogProvider_1.SiteUrlsProvider, { siteUrls: siteUrls },
        React.createElement(WarningStatusChip, __assign({}, rest))));
}
exports.EmbeddableWarningStatusChip = EmbeddableWarningStatusChip;
function WarningStatusChip(props) {
    var _a = usePanelState(DataQualityWarningStatusChipId), isDialogOpen = _a.isDialogOpen, onCloseRequest = _a.onCloseRequest, ref = _a.ref, rest = __rest(_a, ["isDialogOpen", "onCloseRequest", "ref"]);
    if (shouldSkipWarningDueToNoIndicators(props)) {
        return null;
    }
    var _b = buildWarningTooltipAndPanelProps(props), warningKind = _b.warningKind, title = _b.title, indicators = _b.indicators;
    return (React.createElement(SiteUrlsContext_1.SiteUrlsContext.Provider, { value: props.urls || SiteUrlsContext_1.noopSiteUrls },
        React.createElement(DataQualityIndicatorButtons_1.DataQualityWarningInteractiveButton, __assign({}, rest, { warningKind: warningKind, title: title, ref: ref, tabIndex: props.tabIndex })),
        isDialogOpen &&
            React.createElement(DataQualityIndicatorDetailPanel, { indicators: indicators, onCloseRequest: onCloseRequest, side: props.side || 'right', title: title, anchorEl: ref.current, stackingRootId: props.stackingRootId })));
}
exports.WarningStatusChip = WarningStatusChip;
function certificationTooltipTitle(props) {
    if (props.anchoredCertifications.length <= 0) {
        return '';
    }
    switch (props.kind) {
        case 'vizportal':
            return DataQualityType_1.localizeDataQualityTypeName(DataQualityType_1.stringToDataQualityType(props.anchoredCertifications[0].type));
        case 'graph':
            return DataQualityType_1.localizeDataQualityTypeName(DataQualityType_1.stringToDataQualityType(props.anchoredCertifications[0].__typename));
        default:
            TypescriptHelpers_1.assertUnreachable(props);
            return '';
    }
}
function warningTooltipTitle(props) {
    var _a, _b;
    var count = props.anchoredWarnings.length + props.upstreamWarnings.length + (props.kind === 'graph' ? (_b = (_a = props.anchoredChildWarnings) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0 : 0);
    if (count <= 0) {
        return '';
    }
    if (count === 1) {
        if (props.anchoredWarnings.length === 1) {
            switch (props.kind) {
                case 'vizportal':
                    return DataQualityType_1.localizeDataQualityTypeName(DataQualityType_1.stringToDataQualityType(props.anchoredWarnings[0].type));
                case 'graph':
                    return DataQualityType_1.localizeDataQualityTypeName(DataQualityType_1.stringToDataQualityType(props.anchoredWarnings[0].warningType));
                default:
                    TypescriptHelpers_1.assertUnreachable(props);
                    return '';
            }
        }
    }
    return Localize_1.Messages.DataQualityIconMessage({
        MESSAGE_COUNT: count,
        MESSAGE_COUNT_LOC: Localize_1.Formatters.formatCount(count)
    });
}
function getWarningKind(props) {
    var _a;
    switch (props.kind) {
        case 'graph': {
            if (props.anchoredWarnings.some(function (w) { return w.isSevere; }) || ((_a = props.anchoredChildWarnings) === null || _a === void 0 ? void 0 : _a.some(function (w) { return w.isSevere; }))) {
                return 'severe-warning';
            }
            break;
        }
        case 'vizportal': {
            if (props.anchoredWarnings.some(function (w) { return w.isSevere; })) {
                return 'severe-warning';
            }
            break;
        }
        default:
            TypescriptHelpers_1.assertUnreachable(props);
    }
    return (props.upstreamWarnings.some(function (w) { return w.isSevere; })) ? 'severe-warning' : 'standard-warning';
}
function DataQualityIndicatorDetailPanel(props) {
    var dialogProps = {
        title: props.title || '',
        getAnchorClientRect: function () { return DataQualityIndicatorSharedHelpers_1.getTooltipAnchorClientRect(props.anchorEl); },
        positioningBehavior: widgets_1.DialogPositioningBehavior.Anchored,
        dialogStyle: DataQualityIndicatorStyles_1.IndicatorPanelDialogStyle,
        dialogBodyStyle: DataQualityIndicatorStyles_1.IndicatorDetailPanelDialogBodyStyle,
        anchorOrigin: {
            vertical: widgets_1.VerticalOriginOption.top,
            horizontal: props.side === 'right'
                ? widgets_1.HorizontalOriginOption.right
                : widgets_1.HorizontalOriginOption.left,
        },
        showFooter: false,
        shouldAdjustPositionOnWindowResize: true,
        testId: 'data-quality-detail-panel',
        isModal: true,
        isGlassTransparent: true,
        type: widgets_1.DialogType.Uber,
        showCloseButton: false,
        handleGlassClick: props.onCloseRequest,
        onCloseRequest: props.onCloseRequest,
        shouldReturnFocusOnClose: false,
        disableAutoFocus: true,
        stackingRootId: props.stackingRootId,
    };
    return (React.createElement(widgets_1.DialogWidget, __assign({}, dialogProps),
        React.createElement(DataQualityIndicatorDetail_1.RenderAssetsIndicators, __assign({}, props.indicators))));
}
//# sourceMappingURL=DataQualityIndicatorStatusChip.js.map